/* Styles */
import "../../styles/Testimonial/testimonialSubmit.scss";
/* Libs */
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { useLocation} from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import React, {  useEffect, useState } from "react";
import _ from "lodash";
/* Components */
import { dataTestimonial } from "../../controllers/dataTestimonial";
import { TestiHeader } from "./TestimonialHeader/testiHeader";
import { TestiOrders } from "./TestimonialOrders/testiOrders";
import { TestiPhotos } from "./TestimonialPhotos/testiPhotos";
import { TestiStory } from "./TestimonialStory/testiStory";
import ModalAlert from "../UI/Modal/modalAlert";
import { ModalSuccess } from "../UI/Modal/modalSuccesful";
/* Controllers - Helpers */
import { inputValidator } from "../../helpers/inputValidator";
import { getOrdersID } from "../../helpers/getDataOrders.js";
import { signIn } from "../../controllers/basicAuth";


export const TestimonialSubmit = () => {
  const location = useLocation();
  let tempLocationState;
  if(location.state){
    tempLocationState=location.state;
  }else{
    tempLocationState=undefined || {};
    window.location.href="/pages/win-your-wedding-flowers"
  }
  const { emailState, externalState, tokenState, internalState } = tempLocationState;
  const initValues = {
    errorShowModal: false,
    headMsg: "",
    bodyMsg: "",
  };
  const [values, setValues] = useState(initValues);
  const { errorShowModal, headMsg, bodyMsg } = values;
  const [token, setToken] = useState(tokenState);
  const [succesModal, setsuccesModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    data: [],
  });
  const orderID = internalState;
  const externalOrderID = externalState;
  const emailCustomer = emailState;

  useEffect(() => {
    async function fetchData() {
      setLoading(false);
      if (!token) {
        reNewToken();
      } else {
        await getOrdersID(orderID, token)
          .then((data) => {
            setData({ data: data });
            setLoading(true);
          })
          .catch((error) => {
            console.log("error", error);
            setData({ data: [] });
            window.location.href="/pages/win-your-wedding-flowers"
          });
      }
    }
    fetchData();
  }, [token]);

  async function reNewToken() {
    await signIn()
      .then((value) => setToken(value))
      .catch((error) => console.log("error", error));
  }
  const showModalSuccessError = (value, label) => {
    if (value) {
      setValues({
        ...values,
        errorShowModal: true,
        headMsg: "Submitted",
        bodyMsg: " Your Story has been submitted Successfully! <br/>" + label,
      });
    } else {
      setValues({
        ...values,
        errorShowModal: true,
        headMsg: "Error Found",
        bodyMsg:
          "Something Wrong Happen while submitting your story, please try again ",
      });
    }
  };
  const restartModal = (errorFound) => {
    if (errorFound) {
      setTimeout(
        () =>
          setValues({
            ...values,
            errorShowModal: false,
            headMsg: "",
            bodyMsg: "",
          }),
        1000
      );
      return true;
    }
    return false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let targetLength = e.target.length;
    let tmpArrayData = {};
    let tmpArrayProducts = [];
    let data4send = { images: {}, products: [], videos: {} };
    let products = data.data.products;
    let getSubmitButton = document.getElementById("submitBtn");
    //get all data & validate
    for (let i = 0; i < targetLength; i++) {
      const { error, errorShowModal, headMsg, bodyMsg } = await inputValidator(
        e.target[i].name,
        e.target[i].getAttribute("label"),
        e.target[i].value,
        e.target[i].checked
      );
      if (error) {
        setValues({
          ...values,
          errorShowModal: errorShowModal,
          headMsg: headMsg,
          bodyMsg: bodyMsg,
        });
        restartModal(true);
        return;
      } else {
        tmpArrayData[e.target[i].name] = e.target[i].value;
      }
    }

    //prepare product data of each one
    products.map((product) => {
      let productId = product.id;
      let productUsed = [6];
      let productReview = "";
      let productRate = 0;

      let tmp_productUsed = _.find(tmpArrayData, (value, key) => {
        return key === "proUsed_" + productId ? value : "";
      });
      productReview = _.find(tmpArrayData, (value, key) => {
        return key === "textreview_" + productId ? value : "";
      });
      productRate = _.find(tmpArrayData, (value, key) => {
        return key === "review_" + productId ? value : 0;
      });

      if (tmp_productUsed) {
        productUsed = tmp_productUsed.split(",").map(function (item) {
          return parseInt(item, 10);
        });
      }
      if (!productReview) {
        productReview = "...";
      }
      tmpArrayProducts.push({
        productId: product.id,
        productRate: productRate,
        productUsed: productUsed,
        productReview: productReview,
      });
    });
    //prepare array with clean data
    for (let i = 0; i < targetLength; i++) {
      let name = e.target[i].name;
      let value = e.target[i].value;
      let type = e.target[i].type;
      if (
        type === "checkbox" ||
        name.includes("proUsed") ||
        name.includes("review") ||
        name.includes("textreview")
      ) {
        continue;
      }
      switch (name) {
        case "imageArray":
          let tmpImageArray = value.split(",");
          for (let index = 0; index < tmpImageArray.length; index++) {
            const element = tmpImageArray[index];
            data4send.images[index] = element;
          }
          continue;
          break;
        case "videoArray":
          let tmpVideoArray = value.split(",");
          for (let index = 0; index < tmpVideoArray.length; index++) {
            const element = tmpVideoArray[index];
            data4send.videos[index] = element;
          }
          continue;
          break;
        case "eventDate":
          let event = new Date(value).toISOString()
            ? new Date(value).toISOString()
            : new Date().toISOString();
          data4send[name] = event;
          break;
        default:
          data4send[name] = value;
          break;
      }
    }
    data4send.products = tmpArrayProducts;
    const answerTestimonial = await dataTestimonial(data4send, token)
      .then((response) => {
        return { answer: response, status: true };
      })
      .catch((error) => {
        console.log("error", error);
        return { answer: error, status: false };
      });
    if (answerTestimonial) {
      setsuccesModal(true);
      getSubmitButton.disabled = true;
    } else {
      showModalSuccessError(false);
      restartModal(true);
    }
  };
  const fullPage = () => {
    return (
      <Container className="font-family">
        <Row>
          <Col xl={12} className="testimonial_container">
            <div className="testimonial_header">
              <h1>Tell your Story! </h1>
            </div>
            <hr />
            <div className="testimonial_subheader">
              <h1>{data.data["shipping_names"]}</h1>
            </div>
            <GoogleReCaptchaProvider
              reCaptchaKey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
              scriptProps={{ async: true }}
            >
              <form onSubmit={handleSubmit}>
                <div className="container_components">
                  <TestiHeader
                    orderID={orderID}
                    externalOrderID={externalOrderID}
                    data={data}
                    key={"TestimonialHeader"}
                  />
                  <input
                    type="hidden"
                    name="customerName"
                    id="customerName"
                    value={data.data["shipping_names"]}
                  />
                  <input
                    type="hidden"
                    name="customerEmail"
                    id="customerEmail"
                    value={emailCustomer}
                  />
                </div>
                <div className="container_components">
                  <TestiOrders
                    orderID={orderID}
                    data={data}
                    key={"TestimonialOrders"}
                  />
                </div>
                <div className="container_components">
                  <TestiPhotos
                    orderID={orderID}
                    data={data}
                    key={"TestimonialPhotos"}
                  />
                </div>
                <div className="container_components">
                  <TestiStory
                    orderID={orderID}
                    data={data}
                    key={"TestimonialStory"}
                  />
                </div>
                <div></div>
                <div className="submitButton">
                  <button
                    className="styled-submit button button-1"
                    type="submit"
                    name="submitBtn"
                    id="submitBtn"
                  >
                    Submit Your Story
                  </button>
                </div>
              </form>
            </GoogleReCaptchaProvider>
          </Col>
        </Row>
        <ModalAlert
          errorGet={errorShowModal}
          msgHead={headMsg}
          msgBody={bodyMsg}
        />
        <ModalSuccess showModal={succesModal} />
      </Container>
    );
  };
  return <>{!loading ? null : fullPage()}</>;
};
export default TestimonialSubmit;
